import React from 'react';
import { VictoryLabel, VictoryPie, VictoryTooltip } from 'victory';

const CustomLabel = (props: any) => {
    return (
      <>
        <VictoryLabel {...props} />
        <VictoryTooltip
          {...props}
          x={200}
          y={250}
          orientation='top'
          pointerLength={0}
          cornerRadius={50}
          flyoutWidth={100}
          flyoutHeight={100}
          flyoutStyle={{ fill: 'black', fontSize: '20px' }}
        />
      </>
    );
}

export const ChartPieComponent = (pData: any, pProperties: any) => {
  const colorScale = pData.map((line: any) => line.color);
  const fitParent = pProperties?.fitParent === true;
  const chartWidth = pProperties?.chartWidth ?? 400;
  const chartHeight = pProperties?.chartHeight ?? 400;
  const labelRadius =
    pProperties?.labelRadius ?? Math.round(Math.min(chartWidth, chartHeight) * 0.4);

  return (
    <>
      <VictoryPie
        responsive={fitParent}
        width={chartWidth}
        height={chartHeight}
        style={{
          labels: { fill: 'black', fontSize: pProperties.fontSizeGraphic },
          parent: fitParent ? { width: '100%', height: '100%' } : { position: 'relative', left: '3vw' },
        }}
        innerRadius={pProperties.innerRadius}
        labelRadius={labelRadius}
        labels={({ datum }) =>
          `${datum.note} ${datum.pourcentage}`
        }
        labelComponent={<CustomLabel {...pProperties} />}
        data={pData}
        labelPosition={(index) => (index ? 'centroid' : 'startAngle')}
        colorScale={colorScale}
      />
    </>
  );
};
